import { useParams } from 'react-router-dom';

import LessonAlerts from '@/components/shared/NegativeAlerts/Lesson';
import { blockedStatus } from '@/interfaces/course';
import { lessonsApi } from '@/services/lesson';
import styled, { StyledProp } from '@/styled';

import LessonType from './Types';

function LessonArea({ className }: StyledProp) {
  const { id } = useParams();
  const { data, isFetching } = lessonsApi.endpoints.getLessons.useQueryState(id);

  if (isFetching) return null;

  return (
    <div className={className}>
      <LessonAlerts />
      {!blockedStatus.includes(data?.status) &&
        (data?.contents ?? []).map((content, index) => <LessonType key={index} {...content} />)}
    </div>
  );
}

export default styled(LessonArea)`
  width: 100%;
  margin-bottom: ${({ theme }) => theme.space.spacing(9)};
  min-height: 400px;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.space.pxToRem(32)};

  img {
    width: 100%;
  }
`;
